import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import DropdownButton from '../../shared/styledComponents/DropdownButton';

export default InjectedStyledComponent(DropdownButton, 'iconDropdown', ['button']);